module.exports = __webpack_public_path__ + "assets/img/d0f63cf35b737acd8aa555d7270d97bd.svg";